<template>
  <div class="strategy-page">
    <hint-page v-if="!confirmPage && showHint" @close="showHint = false">
      <i
        >BE AS DETAILED IN YOUR METHODS AS POSSIBLE, DON'T FORGET TO JUSTIFY
        YOUR ACTIONS THOROUGHLY. <br><br>WE SUGGEST 10MINS PER SECTION.</i
      >
    </hint-page>
    <hint-page v-show="showSelectedTask" @close="showSelectedTask = false">
      <i>your selected task is&nbsp;</i>
      <b>{{ task }}</b>
    </hint-page>
    <hint-page
      v-show="showSelectedArchetype"
      @close="showSelectedArchetype = false"
    >
      <i>your selected archetype is&nbsp;</i>
      <b>{{ selectedArchetypeText }}</b>
    </hint-page>
    <hint-page v-show="showSelectedRole" @close="showSelectedRole = false">
      <i>your selected role is&nbsp;</i>
      <b>{{ selectedRoleText }}</b>
    </hint-page>

    <div v-show="strategyActiveTab === 'objectives'">
      <adv-title>state your objectives</adv-title>
      <textarea
        v-model="objective"
        placeholder="TYPE HERE…"
        :disabled="!user.isController"
      ></textarea>
    </div>

    <div v-show="strategyActiveTab === 'target'">
      <adv-title>identify your targets</adv-title>
      <textarea
        v-model="target"
        placeholder="TYPE HERE…"
        :disabled="!user.isController"
      ></textarea>
    </div>

    <div v-show="strategyActiveTab === 'method'">
      <adv-title>what is your process?</adv-title>
      <textarea
        v-model="method"
        placeholder="TYPE HERE…"
        :disabled="!user.isController"
      ></textarea>
    </div>

    <div v-show="strategyActiveTab === 'impact'">
      <adv-title>what is the outcome?</adv-title>
      <textarea
        v-model="impact"
        placeholder="TYPE HERE…"
        :disabled="!user.isController"
      ></textarea>
    </div>

    <page-subnav v-if="!confirmPage">
      <page-subnav-item
        @click="showSelectedTask = true"
        :active="showSelectedTask"
        >task</page-subnav-item
      >
      <page-subnav-item
        @click="showSelectedArchetype = true"
        :active="showSelectedArchetype"
        >Archetype</page-subnav-item
      >
      <page-subnav-item
        @click="showSelectedRole = true"
        :active="showSelectedRole"
        >Role</page-subnav-item
      >
    </page-subnav>

    <page-subnav-tabs>
      <page-subnav-item
        :active="strategyActiveTab === 'objectives'"
        :disabled="!user.isController"
        @click="$store.dispatch('setStrategyTab', 'objectives')"
        >aim</page-subnav-item
      >

      <page-subnav-item
        :active="strategyActiveTab === 'target'"
        :disabled="!user.isController"
        @click="$store.dispatch('setStrategyTab', 'target')"
        >target</page-subnav-item
      >

      <page-subnav-item
        :active="strategyActiveTab === 'method'"
        :disabled="!user.isController"
        @click="$store.dispatch('setStrategyTab', 'method')"
        >method</page-subnav-item
      >

      <page-subnav-item
        :active="strategyActiveTab === 'impact'"
        :disabled="!user.isController"
        @click="$store.dispatch('setStrategyTab', 'impact')"
        >impact</page-subnav-item
      >
    </page-subnav-tabs>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import HintPage from "./HintPage.vue";
import PageSubnav from "../components/PageSubnav";
import PageSubnavItem from "../components/PageSubnavItem";
import PageSubnavTabs from "../components/PageSubnavTabs";
import AdvTitle from "../components/AdvTitle.vue";

export default {
  name: "strategy-page",
  props: {
    confirmPage: Boolean,
  },
  components: {
    HintPage,
    PageSubnav,
    PageSubnavTabs,
    PageSubnavItem,
    AdvTitle,
  },
  data: function () {
    return {
      showHint: true,
      showSelectedTask: false,
      showSelectedArchetype: false,
      showSelectedRole: false,
    };
  },
  computed: {
    ...mapState([
      "user",
      "selectedSide",
      "strategyActiveTab",
      "pageName",
      "objectiveText",
      "targetText",
      "methodText",
      "impactText",
      "task",
    ]),
    ...mapGetters(["task", "selectedArchetypeText", "selectedRoleText"]),
    objective: {
      set(val) {
        this.$store.commit("SET_OBJECTIVE", val);
      },
      get() {
        return this.objectiveText;
      },
    },
    target: {
      set(val) {
        this.$store.commit("SET_TARGET", val);
      },
      get() {
        return this.targetText;
      },
    },
    method: {
      set(val) {
        this.$store.commit("SET_METHOD", val);
      },
      get() {
        return this.methodText;
      },
    },
    impact: {
      set(val) {
        this.$store.commit("SET_IMPACT", val);
      },
      get() {
        return this.impactText;
      },
    },
  },
};
</script>

<style lang="less">
.strategy-page {
  width: 768px;
  height: 768px;
  padding: 120px;
  position: relative;
  background-image: url("~@/assets/images/page-blank.png");
  // font-style: italic;

  textarea {
    background-color: rgba(255, 255, 255, 0);
    border: none;
    outline: none;
    display: block;
    width: 530px;
    height: 530px;
    resize: none;
    text-transform: uppercase;
    font-style: italic;
    // color: #f1ece6;

    &::placeholder {
      opacity: 1;
    }
  }

  .confirm-icon {
    position: absolute;
    top: 90px;
    left: 90px;
    // width: 60px;
    // height: 60px;
    // padding: 9px 0 0 9px;
    cursor: pointer;
    z-index: 999;
  }
}
</style>
